import wehagoConfig from './wehago';
import devConfig from './dev';
import wehagoTestConfig from './wehagoTest';
import type { ConferenceConfig } from './types';

type AppType = 'wehago' | 'wehagov' | 'wehagom' | 'wehagoTest' | 'productDev' | 'video2';

const appType = (import.meta.env.VITE_APP_TYPE as AppType | undefined) ?? 'dev';

const configMap: Record<AppType | 'dev', ConferenceConfig> = {
  wehago: wehagoConfig,
  wehagov: wehagoConfig,   // TODO: 공공 전용 서버 설정 있으면 별도 파일로 분리
  wehagom: wehagoConfig,   // TODO: 모바일 전용 설정 있으면 별도 파일로 분리
  wehagoTest: wehagoTestConfig,
  productDev: wehagoTestConfig,
  video2: wehagoConfig,    // TODO: video2 전용 서버 설정 있으면 별도 파일로 분리
  dev: devConfig,
};

const config: ConferenceConfig = configMap[appType] ?? devConfig;

export default config;
export type { ConferenceConfig };
